import React from 'react';
import { DualBoxItem, DualBoxWrapper } from './StartPageDualBox';
import { Above } from '@jetshop/ui/Breakpoints';

export const StartPageSingleBox = ({
  desktopImage,
  mobileImage,
  desktopAspectRatio,
  mobileAspectRatio,
  html,
  textShadow,
  buttonText,
  buttonTextFontWeight,
  buttonTextColor,
  buttonBackgroundColor,
  verticalAlignment,
  link,
}) => {
  return (
    <DualBoxWrapper>
      <Above breakpoint="md">
        {(matches) => (
          <DualBoxItem
            image={matches ? desktopImage : mobileImage}
            html={html}
            textShadow={textShadow}
            buttonText={buttonText}
            buttonTextFontWeight={buttonTextFontWeight}
            buttonTextColor={buttonTextColor}
            buttonBackgroundColor={buttonBackgroundColor}
            verticalAlignment={verticalAlignment}
            link={link}
            aspectRatio={matches ? desktopAspectRatio : mobileAspectRatio}
          />
        )}
      </Above>
    </DualBoxWrapper>
  );
};
